module.exports = __webpack_public_path__ + "assets/e8037326fafb087803ea12c1523244d9.mp4";